export const downloadBlob = ({ blob, filename }: { blob: Blob; filename: string }) => {
  const link = document.createElement('a')

  link.href = window.URL.createObjectURL(blob)

  link.download = filename

  document.body.appendChild(link)

  link.click()

  document.body.removeChild(link)

  window.URL.revokeObjectURL(link.href)
}
